<template>
    <v-dialog v-model="dialog" max-width="450">
        <template v-slot:activator="{ on }">
            <v-fab-transition>
                <v-btn
                    icon
                    v-on="on"
                    text
                    class="px-0 error--text"
                    :title="details.active ? $t('Активный. Нажмите для блокирования') : $t('Заблокирован. Нажмите для разблокирования')"
                >
                    <v-icon v-if="details.active" dense>lock_open</v-icon>
                    <v-icon v-else dense>lock</v-icon>
                </v-btn>
            </v-fab-transition>
        </template>

        <v-card style="border-radius: 10px">
            <!-- <v-card-title class="edit-header"></v-card-title> -->
            <p class="dialog-header"><v-spacer /><v-icon @click="dialog = false" class="mx-1 my-1 white--text pointer">close</v-icon></p>
            <v-card-text>
                <center v-if="details.active" class="pt-2" style="font-size: 16px !important">{{ blockMessage }}</center>
                <center v-else class="pt-2" style="font-size: 16px !important">{{ unBlockMessage }}</center>
            </v-card-text>
            <v-card-actions class="d-flex justify-center">
                <v-btn outlined @click="dialog = false" color="info" class="popup-btn rounded-btn">{{ $t('Нет') }}</v-btn>

                <v-btn color="info" @click="doUpdate()" style="margin-left: 30px !important" class="popup-btn rounded-btn">{{ $t('Да') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import { sprintf } from 'sprintf-js';

export default {
    computed: {
        blockMessage() {
            return sprintf(
                this.$t('Вы подтверждаете блокировку пользователя %s (%s)? Работа пользователя в программе будет завершена'),
                this.details.user_data.name,
                this.details.email
            );
        },
        unBlockMessage() {
            return sprintf(this.$t('Вы подтверждаете разблокировку пользователя %s (%s)?'), this.details.user_data.name, this.details.email);
        }
    },
    props: ['details'],
    data() {
        return {
            dialog: false
        };
    },
    methods: {
        ...mapActions('users', ['updateIsActive']),
        async doUpdate() {
            this.dialog = false;
            await this.updateIsActive({
                user_id: this.details.record_id,
                active: !this.details.active
            });
        }
    }
};
</script>

<style>
.popup-btn {
    display: block;
    margin: auto;
}
</style>
